import { useState } from 'react';
import { Avatar, Icon } from '@getpay93/ui';
import { useAuth } from '../auth/AuthContext';

export function ProfileSwitcher() {
  const { session, switchOrg } = useAuth();
  const [open, setOpen] = useState(false);
  if (!session) return null;
  const active = session.profiles.find((p) => p.orgId === session.org?.id) ?? session.profiles[0];

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label={active?.orgName ?? 'Perfil'}
        style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, padding: '6px 10px', cursor: 'pointer', color: 'var(--text-body)', fontFamily: 'var(--font-sans)', fontWeight: 700 }}
      >
        <Avatar name={active?.orgName ?? '?'} tone="solid" size="sm" />
        <span style={{ maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{active?.orgName}</span>
        <Icon name="chevron-down" size={16} />
      </button>
      {open ? (
        <div style={{ position: 'absolute', right: 0, top: '110%', minWidth: 220, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, boxShadow: 'var(--shadow-raised)', padding: 6, zIndex: 20 }}>
          {session.profiles.map((p) => (
            <button
              key={p.orgId}
              onClick={async () => {
                setOpen(false);
                if (p.orgId !== session.org?.id) await switchOrg(p.orgId);
              }}
              style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', textAlign: 'left', padding: '8px 10px', borderRadius: 10, border: 'none', background: p.orgId === session.org?.id ? 'var(--brand-green-soft)' : 'transparent', cursor: 'pointer', fontFamily: 'var(--font-sans)', color: 'var(--text-body)' }}
            >
              <Avatar name={p.orgName} tone="slate" size="sm" />
              <span style={{ flex: 1 }}>
                <span style={{ display: 'block', fontWeight: 700 }}>{p.orgName}</span>
                <span style={{ display: 'block', fontSize: 12, color: 'var(--text-hint)' }}>{p.role === 'client' ? 'Cliente' : 'Negocio'}</span>
              </span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
